import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesQueries, dataFetched, pageAndDataFetched } from 'data/graphql'
import { ALL_NOTIFICATIONS_LIST_NAME } from 'data/notifications'
import NotificationsAPI from 'remote/notifications'

const fetchesLastFiveNotifications = ({ queryOnMount = true } = {}) =>
  compose(
    connect(
      null,
      {
        dataFetched,
        pageAndDataFetched,
      }
    ),
    makesQueries({
      queryOnMount,
      resyncPolicy: 'refetch',
      query: NotificationsAPI.fetchLastFiveNotifications,
      mapPropsToVariables: () => {},
      getOnResultFromProps: ({ dataFetched, pageAndDataFetched }) => ({
        result,
      }) => {
        const { notifications } = result.data.getUsersNotifications
        dataFetched(result.data.getUsersNotifications)
        pageAndDataFetched(ALL_NOTIFICATIONS_LIST_NAME, notifications)
      },
    })
  )
export default fetchesLastFiveNotifications
